import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  StyledPCPErrorViewIcon,
  StyledPCPErrorViewStack,
} from './ChoosePCPLocation.styled';

export const UpdatePCPErrorView = () => {
  const { t } = useTranslation();

  return (
    <StyledPCPErrorViewStack alignLayout="center">
      <StyledPCPErrorViewIcon icon="alert" size="80" variant="twotone" />
      <Heading.Level>
        <Heading level={2} size="md">
          {t('CHOOSE_PCP_FLOW.ERROR_MODAL.WERE_SORRY')}
        </Heading>
      </Heading.Level>
      <Text>
        {t('CHOOSE_PCP_FLOW.ERROR_MODAL.ERROR_MESSAGE_PAGE_NOT_AVAILABLE')}
      </Text>
    </StyledPCPErrorViewStack>
  );
};
